import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const PLUGINS = [remarkGfm];

const components = {
  h1: ({ children }) => <h3 className="text-base font-semibold text-white mt-3 mb-1 first:mt-0">{children}</h3>,
  h2: ({ children }) => <h3 className="text-base font-semibold text-white mt-3 mb-1 first:mt-0">{children}</h3>,
  h3: ({ children }) => <h4 className="text-sm font-semibold text-ism-teal mt-3 mb-1 first:mt-0">{children}</h4>,
  h4: ({ children }) => <h4 className="text-sm font-semibold text-ism-teal mt-2 mb-1 first:mt-0">{children}</h4>,
  p: ({ children }) => <p className="text-sm leading-relaxed mb-2 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5 mb-2 space-y-1 marker:text-ism-teal">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 space-y-1 marker:text-ism-teal">{children}</ol>,
  li: ({ children }) => <li className="text-sm leading-relaxed">{children}</li>,
  hr: () => <hr className="border-white/10 my-3" />,
  strong: ({ children }) => <strong className="font-semibold text-white">{children}</strong>,
  em: ({ children }) => <em className="text-gray-200">{children}</em>,
  a: ({ href, children }) => <a href={href} target="_blank" rel="noopener noreferrer" className="text-ism-teal underline underline-offset-2 hover:text-ism-teal/80">{children}</a>,
  code: ({ children }) => <code className="rounded bg-black/30 px-1 py-0.5 text-[12px] text-ism-teal">{children}</code>,
  blockquote: ({ children }) => <blockquote className="border-l-2 border-ism-teal/40 pl-3 text-gray-400 my-2">{children}</blockquote>,
};

// Assistant replies arrive as markdown (headings, bullets, --- dividers); render them instead of showing raw symbols.
export const MarkdownMessage = ({ text, testId }) => (
  <div className="text-gray-300" data-testid={testId}>
    <ReactMarkdown components={components} remarkPlugins={PLUGINS}>{text || ""}</ReactMarkdown>
  </div>
);
